import {
  BasicInsuranceCoveragePayerEnum,
  CurrentSavingsAllowance,
  CurrentSavingsWealth,
  DevelopmentalDisabilityEnum,
  DiscountTermsEnum,
  ExclusionTypeEnum,
  IncludesSavingsEnum,
  IndexLinkedPensionEnum,
  InsuranceCoveragePayerEnum,
  InsuranceCoveragePaymentMethodEnum,
  InsurancePolicyPaymentFrequencyEnum,
  InsurancePolicyPaymentMethodEnum,
  InsuredTypeEnum,
  OccupationTypeEnum,
  PensionCategoriesEnum,
  PersonalAndGroupTypeEnum,
  PolicyStatusEnum,
  PosStandType,
  WaiverStatusType,
} from "./../types/portfolio"

export const PensionCategories: Record<PensionCategoriesEnum, string> = {
  [PensionCategoriesEnum.PENSION]: "קרן פנסיה",
  [PensionCategoriesEnum.EDUCATION]: "קרן השתלמות",
  [PensionCategoriesEnum.INVESTMENT]: "גמל להשקעה",
  [PensionCategoriesEnum.MANAGERS]: "ביטוח מנהלים",
  [PensionCategoriesEnum.CHILDSAVING]: "חיסכון לכל ילד",
  [PensionCategoriesEnum.PROVIDENT]: "קופת תגמולים",
  [PensionCategoriesEnum.COMPREHENSIVE]: "פנסיה מקיפה",
  [PensionCategoriesEnum.COMPERHENSIVE]: "פנסיה מקיפה",
  [PensionCategoriesEnum.SUPPLEMENTARY]: "פנסיה משלימה",
  [PensionCategoriesEnum.INSURANCE]: "כיסויים ביטוחיים",
  [PensionCategoriesEnum.OTHER]: "אחר",
} as const

export const SectionTitles = {
  InsuranceCoverage: "כיסויים ביטוחיים",
  InvestmentPlans: "מסלולי השקעה",
  Savings: "חיסכון",
  DepositsAndDetails: "נתונים והפקדות",
  PaymentsAndDetails: "נתונים ותשלומים",
} as const

export const AccordionTitles = {
  Payments: "תשלומים",
  Deposits: "הפקדות",
  ManagementFees: "דמי ניהול",
  AdditionalDetails: "נתונים נוספים",
  Mitriyot: "מטריות",
  EarlyDeathCoverage: "למקרה פטירה מוקדמת",
  DisabiltyCoverage: "למקרה אובדן כושר עבודה",
  AdditionalDeathCoverages: "כיסויים ביטוחיים נוספים",
} as const

export const PolicyStatuses: Record<PolicyStatusEnum, string> = {
  [PolicyStatusEnum.ACTIVE]: "פעיל",
  [PolicyStatusEnum.INACTIVE]: "לא פעיל",
  [PolicyStatusEnum.CANCELLED]: "מבוטל",
  [PolicyStatusEnum.UNDER_CLAIM]: "בתביעה",
  [PolicyStatusEnum.TEMPORARY_RISK]: "ריסק זמני",
  [PolicyStatusEnum.PERIOD_EXPIRED]: "תום תקופה",
  [PolicyStatusEnum.BLOCKED_FOR_DEPOSITS]: "חסום להפקדות",
  [PolicyStatusEnum.AUTOMATIC_TEMPORARY_RISK]: "ריסק זמני אוטומטי",
  [PolicyStatusEnum.INSURANCE_COVERAGE_KEEPING]: "שמירת כיסוי ביטוחי",
  [PolicyStatusEnum.NOT_RELEVANT]: "לא רלוונטי",
} as const

export const PosStandTitles: Record<PosStandType, string> = {
  [PosStandType.EMPLOYEE]: "שכיר",
  [PosStandType.SELF_EMPLOYED]: "עצמאי",
  [PosStandType.CONTROLLING_OWNER]: "בעל שליטה",
  [PosStandType.PRIVATE]: "פרט",
  [PosStandType.CUSTOM]: "מיוחד",
  [PosStandType.OTHER]: "אחר",
} as const

export const WaiverStatusTitles: Record<WaiverStatusType, string> = {
  [WaiverStatusType.NOT_EXISTS]: "לא קיים",
  [WaiverStatusType.FULL_WAIVER]: "קיים ויתור מלא",
  [WaiverStatusType.CHILDREN_ONLY]: "קיים ויתור לילדים בלבד",
  [WaiverStatusType.SPOUSE_ONLY]: "קיים ויתור לבן/בת זוג בלבד",
} as const

export const WealthCurrentSavings: Record<keyof NonNullable<CurrentSavingsWealth>, string> = {
  taxExemptBefore2002: "סכום צבירה פטור ממס עד לתאריך 31.12.2002",
  withinTaxCeilingFrom2003: "סכום צבירה עד לתקרת מס מתאריך 1.1.2003 ",
  aboveTaxCeiling: "סכום צבירה מעל לתקרת מס",
  employeeTagmulim: "תגמולי עובד",
  employerTagmulim: "תגמולי מעביד",
} as const

export const AllowanceCurrentSavings: Record<keyof NonNullable<CurrentSavingsAllowance>, string> = {
  currentEmployerCompensation: "פיצויים למעסיק נוכחי",
  pastEmployerCompensation: "פיצויים מעסיקים קודמים",
  employeeTagmulim: "תגמולי עובד",
  employerTagmulim: "תגמולי מעביד",
} as const

export const InsuredTypeTitles: Record<InsuredTypeEnum, string> = {
  [InsuredTypeEnum.OTHER]: "אחר",
  [InsuredTypeEnum.PRIMARY]: "אישי",
  [InsuredTypeEnum.SECONDARY]: "משני",
  [InsuredTypeEnum.CHILD]: "ילד",
  [InsuredTypeEnum.MUTUAL]: "הדדי",
} as const

export const InsurancePolicyPaymentMethodTitles: Record<InsurancePolicyPaymentMethodEnum, string> = {
  [InsurancePolicyPaymentMethodEnum.BANK_TRANSFER]: "העברה בנקאית",
  [InsurancePolicyPaymentMethodEnum.DIRECT_DEBIT]: "הוראת קבע",
  [InsurancePolicyPaymentMethodEnum.CREDIT_CARD]: "כרטיס אשראי",
  [InsurancePolicyPaymentMethodEnum.OTHER]: "אחר",
  [InsurancePolicyPaymentMethodEnum.CHECK]: "המחאה",
} as const

export const InsurancePolicyPaymentFrequencyTitles: Record<InsurancePolicyPaymentFrequencyEnum, string> = {
  [InsurancePolicyPaymentFrequencyEnum.MONTHLY]: "חודשי",
  [InsurancePolicyPaymentFrequencyEnum.QUARTERLY]: "רבע שנתי",
  [InsurancePolicyPaymentFrequencyEnum.SEMI_ANNUALLY]: "חצי שנתי",
  [InsurancePolicyPaymentFrequencyEnum.ANNUALLY]: "שנתי",
  [InsurancePolicyPaymentFrequencyEnum.ONE_TIME]: "חד פעמי",
} as const

export const InsuranceCoveragePaymentMethodTitles: Record<InsuranceCoveragePaymentMethodEnum, string> = {
  [InsuranceCoveragePaymentMethodEnum.OTHER]: "אחר",
  [InsuranceCoveragePaymentMethodEnum.ONE_TIME_AMOUNT]: "סכום חד פעמי",
  [InsuranceCoveragePaymentMethodEnum.ALLOWANCE]: "קצבה",
  [InsuranceCoveragePaymentMethodEnum.PERIODIC_PAYMENTS]: "תשלומים תקופתיים",
  [InsuranceCoveragePaymentMethodEnum.WEALTH_AND_ALLOWANCE]: "הון וקצבה",
} as const

export const InsuranceCoveragePayerTitles: Record<InsuranceCoveragePayerEnum, string> = {
  [InsuranceCoveragePayerEnum.EMPLOYER]: "מעסיק",
  [InsuranceCoveragePayerEnum.EMPLOYEE]: "עובד",
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP]: "מעסיק עם תקרה של אחוז מהשכר",
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_EMPLOYEE_REMAINDER]:
    'מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח העובד',
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_SAVINGS_REMAINDER]:
    'מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח הפרשות',
  [InsuranceCoveragePayerEnum.FROM_SAVINGS]: "מתוך ההפרשות",
}

export const AdditionalInsuranceCoveragePayerTitles = {
  [InsuranceCoveragePayerEnum.EMPLOYER]: "מעסיק תקציב שונות",
  [InsuranceCoveragePayerEnum.EMPLOYEE]: "עובד תקציב שונות",
  [InsuranceCoveragePayerEnum.FROM_SAVINGS]: "מתוך החיסכון",
}

export const DisabilityInsuranceCoveragePayerTitles: Record<InsuranceCoveragePayerEnum, string> = {
  [InsuranceCoveragePayerEnum.EMPLOYER]: "מעסיק עד 2.5% מהשכר",
  [InsuranceCoveragePayerEnum.EMPLOYEE]: " עובד בתקציב נוסף",
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP]: "מעסיק עד 2.5% מהשכר",
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_EMPLOYEE_REMAINDER]:
    'מעסיק עד 2.5% מהשכר והיתרה ע"ח העובד',
  [InsuranceCoveragePayerEnum.EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_SAVINGS_REMAINDER]:
    'מעסיק עד 2.5% מהשכר והיתרה ע"ח החיסכון',
  [InsuranceCoveragePayerEnum.FROM_SAVINGS]: "מתוך החיסכון",
}

export const IncludesSavingsTitles: Record<IncludesSavingsEnum, string> = {
  [IncludesSavingsEnum.YES]: "כן",
  [IncludesSavingsEnum.NO]: "לא",
} as const

export const DiscountTermsEnumTitles: Record<DiscountTermsEnum, string> = {
  [DiscountTermsEnum.ENTIRE_INSURANCE_PERIOD]: "לכל תקופת הביטוח", // 1
  [DiscountTermsEnum.LIMITED_PERIOD]: "לתקופה קצובה", // 2
  [DiscountTermsEnum.EMPLOYMENT_DURATION]: "לתקופת העבודה אצל המעסיק", // 3
  [DiscountTermsEnum.NO_DISCOUNT]: "לא ניתנה הנחה", // 4
  [DiscountTermsEnum.EMPLOYER_CONDITIONAL_PERIOD]: "לא ניתנה הנחה", // 5
} as const

export const ExclusionTypeEnumTitles: Record<ExclusionTypeEnum, string> = {
  [ExclusionTypeEnum.MEDICAL]: "כן, החרגה רפואית",
  [ExclusionTypeEnum.PROFESSIONAL_OR_HOBBY]: "כן, מקצועית או תחביב",
  [ExclusionTypeEnum.NONE]: "לא קיימת",
} as const

export const OccupationTypeEnumTitles: Record<OccupationTypeEnum, string> = {
  [OccupationTypeEnum.UNKNOWN]: "לא ידוע", // 0
  [OccupationTypeEnum.ALL]: "כל עיסוק", // 1
  [OccupationTypeEnum.OTHER]: "עיסוק סביר אחר", // 2
  [OccupationTypeEnum.SPECIFIC]: "עיסוק ספציפי", // 3
} as const

export const IndexLinkedPensionEnumTitles: Record<IndexLinkedPensionEnum, string> = {
  [IndexLinkedPensionEnum.UNKNOWN]: "לא ידוע",
  [IndexLinkedPensionEnum.TWENTY_FOUR_MONTHS]: "24 חודשים",
  [IndexLinkedPensionEnum.THIRTY_SIX_MONTHS]: "36 חודשים",
  [IndexLinkedPensionEnum.FORTY_EIGHT_MONTHS]: "48 חודשים",
  [IndexLinkedPensionEnum.SIXTY_MONTHS]: "60 חודשים",
  [IndexLinkedPensionEnum.ALL_TIME]: "לכל התקופה",
} as const

export const DevelopmentalDisabilityEnumTitles: Record<DevelopmentalDisabilityEnum, string> = {
  [DevelopmentalDisabilityEnum.ONE_PERCENTAGE]: "כן, 1%",
  [DevelopmentalDisabilityEnum.TWO_PERCENTAGE]: "כן, 2% ",
  [DevelopmentalDisabilityEnum.NONE]: "ללא",
} as const

export const PersonalAndGroupTypeEnumTitles: Record<PersonalAndGroupTypeEnum, string> = {
  [PersonalAndGroupTypeEnum.PERSONAL]: "אישי",
  [PersonalAndGroupTypeEnum.GROUP]: "קבוצתי",
  [PersonalAndGroupTypeEnum.PERSONAL_AND_GROUP]: "אישי וקבוצתי",
} as const
